export const statusFilter = (status, list) => {
  return status === 'Todos'
    ? list
    : list.filter(item => item.status && item.status.toUpperCase() === status.toUpperCase())
}



// WEBPACK FOOTER //
// ./src/app/modules/OrdersRequestList/DropdownList/helpers.js